module.exports = __webpack_public_path__ + "static/media/Startsidabeskärd.890a5a6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/Startsidabeskärd.png
// module id = 317
// module chunks = 0